import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { EonLogo } from '../components/shared/EonLogo'
import { IntegritetsLank } from '../components/IntegritetsModal'

export function LoginPage({ onValdVy }) {
  const { logIn, resetPassword } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [glomt, setGlomt] = useState(false)
  const [resetSkickat, setResetSkickat] = useState(false)
  const [valdVy, setValdVy] = useState(null)
  const [visaLosenord, setVisaLosenord] = useState(false)

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      await logIn(email, password)
      if (onValdVy) onValdVy(valdVy)
    } catch (err) {
      setError('Fel e-postadress eller lösenord. Försök igen.')
    } finally {
      setLoading(false)
    }
  }

  async function handleReset(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      await resetPassword(email)
      setResetSkickat(true)
    } catch (err) {
      setError('Kunde inte skicka återställningsmail. Kontrollera e-postadressen.')
    } finally {
      setLoading(false)
    }
  }

  if (!valdVy) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
            <EonLogo size={72} borderRadius={14} />
          </div>
          <h1>E.ON Schema</h1>
          <p className="login-sub">Välj hur du vill logga in</p>
          <button
            className="btn btn-primary btn-full"
            style={{ padding: 14, fontSize: '.95rem', marginBottom: 12, justifyContent: 'center' }}
            onClick={() => setValdVy('admin')}
          >
            🖥 Adminpanel
          </button>
          <button
            className="btn btn-secondary btn-full"
            style={{ padding: 14, fontSize: '.95rem', justifyContent: 'center', border: '1.5px solid #e8e8e8' }}
            onClick={() => setValdVy('app')}
          >
            📱 Medarbetarapp
          </button>
          <div style={{ marginTop: 18, textAlign: 'center' }}>
            <IntegritetsLank />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <EonLogo size={72} borderRadius={14} />
        </div>
        <h1>E.ON Schema</h1>
        <p className="login-sub">
          {glomt ? 'Återställ lösenord' : valdVy === 'admin' ? '🖥 Logga in på adminpanelen' : '📱 Logga in på medarbetarappen'}
        </p>
        {resetSkickat ? (
          <div className="info-box info-box-green" style={{ textAlign: 'left' }}>
            Vi har skickat ett mail till <strong>{email}</strong> med en länk för att välja nytt lösenord.
          </div>
        ) : (
          <form onSubmit={glomt ? handleReset : handleLogin}>
            <div style={{ textAlign: 'left', marginBottom: 11 }}>
              <label className="form-label">E-postadress</label>
              <input
                className="form-control"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="din@eon.se"
                required
                style={{ margin: 0 }}
              />
            </div>
            {!glomt && (
              <div style={{ textAlign: 'left', marginBottom: 8 }}>
                <label className="form-label">Lösenord</label>
                <div style={{ position: 'relative' }}>
                  <input
                    className="form-control"
                    type={visaLosenord ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                    autoComplete="current-password"
                    style={{ margin: 0, paddingRight: 44 }}
                  />
                  <button
                    type="button"
                    onClick={() => setVisaLosenord(!visaLosenord)}
                    style={{
                      position: 'absolute', right: 10, top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none', border: 'none',
                      cursor: 'pointer', fontSize: '1.1rem',
                      color: '#aaa', padding: 0, lineHeight: 1
                    }}
                  >
                    {visaLosenord ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            )}
            {error && (
              <div className="info-box info-box-red" style={{ marginBottom: 12, marginTop: 8 }}>
                {error}
              </div>
            )}
            <div style={{ textAlign: 'right', marginBottom: 16, marginTop: 8 }}>
              <span
                style={{ fontSize: '.8rem', color: '#888', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => { setGlomt(!glomt); setError('') }}
              >
                {glomt ? 'Tillbaka till login' : 'Glömt lösenord?'}
              </span>
            </div>
            <button
              type="submit"
              className="btn btn-primary btn-full"
              style={{ padding: 12, fontSize: '.92rem' }}
              disabled={loading}
            >
              {loading ? 'Väntar...' : glomt ? 'Skicka återställningsmail' : 'Logga in'}
            </button>
          </form>
        )}
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #f0f0f0', textAlign: 'center' }}>
          <span
            style={{ fontSize: '.8rem', color: '#aaa', cursor: 'pointer' }}
            onClick={() => { setValdVy(null); setError('') }}
          >
            Tillbaka
          </span>
        </div>
      </div>
    </div>
  )
}
